import { Box } from '@chakra-ui/layout';
import { PropsWithChildren } from 'react';

export default function Tip(props: PropsWithChildren) {
	return (
		<Box fontSize="sm" mb="4" p="4" background="blue.50" borderRadius="2" borderWidth={1} borderColor="blue.100">
			{props.children}
		</Box>
	);
}
